import { render, staticRenderFns } from "./VanCheen.vue?vue&type=template&id=2596922c&scoped=true"
import script from "./VanCheen.vue?vue&type=script&lang=js"
export * from "./VanCheen.vue?vue&type=script&lang=js"
import style0 from "./VanCheen.vue?vue&type=style&index=0&id=2596922c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2596922c",
  null
  
)

export default component.exports